var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogConsoleDebug = function SvgLogConsoleDebug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19319_35680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.417 3.93103L12.5126 5.73975L11.3071 6.56905",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 8.45285H4.47907",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5205 8.45285H14.3331",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56738 3.93103L3.47174 5.73975L4.67726 6.56905",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40232 12.9747H7.59834C6.09981 12.9747 4.88525 11.7601 4.88525 10.2616V7.5485C4.88525 6.54918 5.69466 5.73978 6.69398 5.73978H9.30668C10.306 5.73978 11.1154 6.54918 11.1154 7.5485V10.2616C11.1154 11.7601 9.90084 12.9747 8.40232 12.9747Z",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56738 12.9746L3.47174 11.1659L4.67726 10.3366",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.417 12.9746L12.5126 11.1659L11.3071 10.3366",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8152 5.73976H6.19775V3.93103C6.19775 3.43183 6.60291 3.02667 7.10212 3.02667H8.91084C9.41005 3.02667 9.8152 3.43183 9.8152 3.93103V5.73976Z",
    stroke: "#4CD266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19319_35680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogConsoleDebug as ReactComponent };
export default __webpack_public_path__ + "log-console-debug.svg";